module.exports = __webpack_public_path__ + "img/send-arrow.0d47ee82.svg";